import {Modal} from '@mantine/core';
import {Z_INDEX} from '../../../constants/zIndex';
import {ModalCancelButton} from './ModalCancelButton';
import {ModalDeleteButton} from './ModalDeleteButton';

type Props = {
  opened: boolean;
  onClose: () => void;
  onDelete: () => void;
  title?: string;
  message?: string;
  isLoading?: boolean;
};

export const DeleteModal: React.FC<Props> = ({
  opened,
  onClose,
  onDelete,
  title = 'このステップを削除しますか？',
  message = 'この操作は取り消しできません。',
  isLoading = false,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      radius={16}
      zIndex={Z_INDEX.MODAL}
    >
      <div className="p-16 text-center">
        <div className="mb-24 text-xl font-bold text-black">{title}</div>
        <div className="mb-24 text-notification">{message}</div>
      </div>
      <div className="flex items-center justify-center gap-12">
        <ModalCancelButton onClick={onClose} disabled={isLoading}>
          キャンセル
        </ModalCancelButton>
        <ModalDeleteButton onClick={onDelete} isLoading={isLoading}>
          削除
        </ModalDeleteButton>
      </div>
    </Modal>
  );
};
